import { LocationOff } from "@mui/icons-material";
import { Button } from "@mui/material";

import { InfoPage } from "../../../shared/components/info-page/info-page";
import { InfoPageIllustration } from "../../../shared/components/info-page/info-page-illustration";
import { InfoPageLayout } from "../../../shared/components/info-page/info-page-layout";
import { SignOutButton } from "../components/sign-out-button";

interface NoFarmsPageProps {
  onRetry: () => void;
}

/**
 * Список хозяйств пользователя успешно получен и пуст: работать в приложении не с чем.
 * Основное действие — выйти; проверка снова — на случай, если хозяйство уже назначили.
 */
export const NoFarmsPage = ({ onRetry }: NoFarmsPageProps): JSX.Element => (
  <InfoPageLayout>
    <InfoPage
      title="Нет назначенных хозяйств"
      message="Обратитесь к администратору, чтобы вам назначили хозяйство"
      illustration={<InfoPageIllustration icon={LocationOff} />}
      actions={
        <>
          <SignOutButton />
          <Button variant="text" color="primary" onClick={onRetry}>
            Проверить снова
          </Button>
        </>
      }
    />
  </InfoPageLayout>
);
